import injectStores from "components/RootStore/injectStores";
import { ScheduleGridHeaderCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";
import { Tooltip } from "components/Tooltip";
import RootStore from "stores/RootStore";
import { RouterStore } from "stores/RouterStore";
import ServiceStore from "stores/ServiceStore";
import { c } from "vite/dist/node/types.d-aGj9QkWt";

interface ProductionScheduleRightHeaderCellProps
  extends ScheduleGridHeaderCellProps {
  currentHeader: {
    key: string | number;
    title: string;
  };
  routerStore?: RouterStore;
  jobStore?: ServiceStore;
  rootStore?: RootStore;
}

interface CurrentClient {
  shortName: string;
  name: string;
}

const ProductionScheduleRightHeaderCell = injectStores(
  (props: ProductionScheduleRightHeaderCellProps) => {
    const routerStore = props.routerStore;
    const jobStore = props.rootStore.jobStore as ServiceStore;
    console.log("props", props);
    const { currentHeader } = props;

    if (!jobStore.entities) {
      return (
        <div
          style={{
            border: "1px solid #eee",
            ...props.style,
            ...props.styles,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <b
            style={{ cursor: "pointer" }}
            onClick={() => {
              console.log(
                "🎯 ProductionOverviewSchedule navigation clicked (no entities):",
                {
                  jobNumber: currentHeader.key,
                  jobNumberType: typeof currentHeader.key,
                }
              );
              routerStore.goTo("ProjectDashboard", {
                projectId: currentHeader.key,
              });
              console.log("✅ Navigation call completed (no entities)");
            }}
          >
            Client ID: {currentHeader?.title}
          </b>
        </div>
      );
    }
    console.log("jobStore.entities", jobStore.entities);
    console.log("currentHeader", currentHeader);
    const currentClient = jobStore.entities.find(
      (i) => i.jobNumber === currentHeader.key
    ) as unknown as CurrentClient;
    console.log("currentClient", currentClient);
    if (!currentClient) {
      return (
        <div
          style={{
            border: "1px solid #eee",
            ...props.style,
            ...props.styles,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <b>Client not found</b>
        </div>
      );
    }
    return (
      <div
        style={{
          border: "1px solid #eee",
          ...props.style,
          ...props.styles,
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Tooltip title="Navigate to Job Dashboard">
          <b
            style={{ cursor: "pointer" }}
            onClick={() => {
              console.log(
                "🎯 ProductionOverviewSchedule navigation clicked (with entities):",
                {
                  jobNumber: currentHeader.key,
                  jobNumberType: typeof currentHeader.key,
                  currentClient: currentClient,
                }
              );
              routerStore.goTo("ProjectDashboard", {
                jobNumber: currentHeader.key,
              });
              console.log("✅ Navigation call completed (with entities)");
            }}
          >
            {currentClient?.shortName
              ? currentClient.shortName
              : currentClient.name}
          </b>
        </Tooltip>
      </div>
    );
  }
);

export default ProductionScheduleRightHeaderCell;
